import { reportError, addBreadcrumb } from './sentry';
import { navigateToPath } from '../lib/navigation';

/**
 * Utility to handle HTTP errors and redirect to appropriate error pages
 */
export const handleHttpError = (
  statusCode: number,
  error?: Error,
  context?: Record<string, any>
) => {
  const errorObj = error || new Error(`HTTP ${statusCode} Error`);

  // Report to Sentry with context
  reportError(errorObj, {
    statusCode,
    httpError: true,
    ...context,
  });

  // Add breadcrumb
  addBreadcrumb(
    `HTTP ${statusCode} error occurred`,
    'error',
    statusCode >= 500 ? 'error' : 'warning'
  );

  // Redirect to appropriate error page
  const errorPath = getErrorPagePath(statusCode);
  if (errorPath && window.location.pathname !== errorPath) {
    navigateToPath(errorPath);
  }
};

/**
 * Get the appropriate error page path for a status code
 */
export const getErrorPagePath = (statusCode: number): string | null => {
  switch (statusCode) {
    case 400:
      return '/400';
    case 404:
      return '/404';
    case 500:
    case 502:
    case 503:
    case 504:
      return '/500';
    default:
      // For other errors, use 500 page
      return statusCode >= 500 ? '/500' : null;
  }
};

/**
 * Check if the current URL is an error page
 */
export const isErrorPage = (): boolean => {
  const path = window.location.pathname;
  return ['/400', '/404', '/500'].includes(path);
};
